import React, { Component } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import isApp from "shared/util/isApp";
import AppPhoneCommand from "shared/util/AppPhoneCommand";
import { isDesktop, isIOS } from "shared/util/EnvironmentHelpers";
import { hasNativeLanding } from "shared/util/AppFeatures";

import { historyPropTypes } from "shared/constants/propTypes";

import SigninModal from "shared/components/SigninModal";
import { SCREENS } from "apps/login/util/constants";

const CAN_GO_BACK_SCREENS = new Set([
	SCREENS.PASSWORD_RESET,
	SCREENS.PASSWORD_SUBMIT,
	SCREENS.SMS_PHONE_INPUT,
	SCREENS.SMS_CODE_INPUT,
	SCREENS.SMS_TWO_FACTOR,
]);

const LOADING_SCREENS = new Set([
	SCREENS.SMS_VALIDATING_CODE,
	SCREENS.SMS_SENDING_CODE,
]);

const withBackgroundWrapper = (WrappedComponent) => class AppWrapper extends Component {
	static propTypes = {
		screen: PropTypes.string,
		previousScreen: PropTypes.string,
		changeScreen: PropTypes.func.isRequired,
		history: historyPropTypes.isRequired,
	};

	static defaultProps = {
		screen: null,
		previousScreen: null,
	}

	componentWillUnmount() {
		this.props.changeScreen(SCREENS.LOGIN);
	}

	handleBackOrClose = () => {
		const { changeScreen, screen, previousScreen, history } = this.props;

		if (isApp() && hasNativeLanding()) {
			AppPhoneCommand("popActivity");
			return;
		}

		if (CAN_GO_BACK_SCREENS.has(screen) && previousScreen) {
			// for screens like code input we don't want to go back to the loading screen
			// so lookup the actual previous screen, otherwise use the previous screen
			// for routes like password reset
			changeScreen(previousScreen);
			return;
		}

		history.push("/");
	}

	renderDesktop = () => {
		const { screen } = this.props;

		const modalClassNames = classNames("login-modal", {
			"login-modal-icon-back": CAN_GO_BACK_SCREENS.has(screen),
			"login-modal-icon-cross": !CAN_GO_BACK_SCREENS.has(screen) && !LOADING_SCREENS.has(screen),
			"login-modal-icon-none": LOADING_SCREENS.has(screen),
		});

		return (
			<SigninModal
				show
				className={modalClassNames}
				onCancel={this.handleBackOrClose}
			>
				<WrappedComponent {...this.props} />
			</SigninModal>
		);
	}

	renderMobile = () => {
		const { screen } = this.props;
		const isIOSApp = isApp() && isIOS;
		const hideBackBtn = isIOSApp && screen === SCREENS.REACTIVATE;

		return (
			<div className="login-mobile-wrapper">
				<div className="login-header-bar">
					{!hideBackBtn &&
						<button className="login-header-bar-close" aria-label="back" onClick={this.handleBackOrClose}>
							<span className="icon" />
						</button>}
				</div>
				<WrappedComponent {...this.props} />
			</div>
		);
	}

	render() {
		return isDesktop ? this.renderDesktop() : this.renderMobile();
	}
};

export default withBackgroundWrapper;



// WEBPACK FOOTER //
// ./src/apps/login/components/withBackgroundWrapper.jsx